import { saveAs } from 'file-saver';
import { getRegistryBuffer } from '../../utils/api';

export const getOneExcel = async (formData, registryId, entityName, entityId, accountId) => {
  let { registryBuffer, registryName } = await getRegistryBuffer(formData, registryId, entityName, entityId, accountId);
  let blob = new Blob([new Uint8Array(registryBuffer.data)], { type: 'application/octet-stream' });
  saveAs(blob, registryName + '.xlsx');
};
